import { useLocation } from 'react-router';
import { useIsResolution } from '@im/ui-lib/responsive';
import { useInX4AFrame } from 'mf_core/config';

export function useXScroll() {
  const isLowResolution = useIsResolution({ max: 1024 });
  const { isInIM360Frame } = useInX4AFrame();
  const { pathname } = useLocation();

  document.getElementById('loaderDiv')?.remove();

  const scrollablePages = [
    '/my/cart',
    '/my/checkout',
    '/my/checkout/new',
    '/my/ordertracking/v3/ordersearch',
  ];

  const enableXScroll =
    (isLowResolution || isInIM360Frame) && scrollablePages.includes(pathname);

  return enableXScroll;
}
